const mutations = {
    SET_USER(state, payload) {
        state.user = payload;
    },
    SET_TENANT_ID(state, payload) {
        state.tenantId = payload;
    },
    SET_TENANT_WAS_SELECTED(state, payload) {
        state.tenantWasSelected = payload;
    },
    SET_ROLES(state, payload) {
        state.roles = payload;
        state.hasAdminRole = payload.some((item) => item.slug !== "basic");
    },
    SET_ACCESS_TOKEN(state, payload) {
        state.accessToken = payload;
    },
    SET_HAS_ADMIN_ROLE(state, payload = false) {
        state.hasAdminRole = payload;
    },
    SET_ACCESS_TOKEN_EXPIRATION_DATE(state, payload) {
        state.tokenExpirationDate = payload;
    },
    SET_MERCHANT_PERMISSIONS(state, payload) {
        state.merchantPermissions = payload;
    },
    SET_GLOBAL_PERMISSIONS(state, payload) {
        state.globalPermissions = payload;
    },
    SET_TENANT_PERMISSIONS(state, payload) {
        state.tenantPermissions = payload;
    },
    SET_PERMISSIONS(state, payload) {
        state.permissions = payload;
    },
    SET_TENANT_NAME(state, payload) {
        state.tenantName = payload;
    },
    SET_TENANT_SLUG(state, payload) {
        state.tenantSlug = payload;
    },
    SET_NEED_ONBOARDING_USER(state, payload) {
        state.needOnboardingUser = payload;
    },
    SET_NEED_ONBOARDING_TENANT(state, payload) {
        state.needOnboardingTenant = payload;
    },
    SET_FEATURE_FLAGS(state, payload) {
        state.featureFlags = payload || {};
    },
    SET_PENDING_LEGAL_DOCUMENTS(state, payload) {
        state.pendingLegalDocuments = Array.isArray(payload) ? payload : [];
    },
    SET_SUBSCRIPTION(state, payload) {
        state.subscription = payload || null;
    },
    SET_SESSION_CORE_LOADED(state, payload) {
        state.sessionCoreLoaded = !!payload;
    },
    SET_ERROR_AUTH(state, payload) {
        state.error = payload;
    },
    CLEAR_AUTH(state) {
        state.user = {
            id: "",
            identificationType: "cc",
            identificationNumber: "",
            username: "",
            firstName: "",
            lastName: "",
            cityCode: "11001",
            address: "",
            neighborhood: "",
            email: "",
            phone: ""
        };
        state.tenantId = "";
        state.tenantWasSelected = false;
        state.accessToken = "";
        state.roles = [];
        state.permissions = [];
        state.globalPermissions = [];
        state.tenantPermissions = [];
        state.merchantPermissions = [];
        state.tokenExpirationDate = 0;
        state.tenantName = "";
        state.tenantSlug = "";
        state.needOnboardingUser = false;
        state.needOnboardingTenant = false;
        state.featureFlags = {};
        state.pendingLegalDocuments = [];
        state.subscription = null;
        state.sessionCoreLoaded = false;
    }
};

export default mutations;
